import { TermDto, TermRestControllerService } from 'generated';
import { useCallback, useEffect, useState } from 'react';
import { apiWrapper } from 'utils/http-client';
import { handleError } from 'utils/utils';

const useAllTermsGet = ({}) => {
  const [content, setContent] = useState<TermDto[]>([]);
  const [loading, setLoading] = useState(false);

  const getAllTerms = useCallback(async () => {
    setLoading(true);
    try {
      const response = await apiWrapper(() => TermRestControllerService.getAllTermsUsingGet());
      setLoading(false);
      setContent(response);
    } catch (err) {
      setLoading(false);
      setContent([]);
      handleError(err);
    }
  }, []);

  useEffect(() => {
    getAllTerms();
  }, [getAllTerms]);

  return {
    loading,
    terms: content,
  };
};

export default useAllTermsGet;
